module.exports = __webpack_public_path__ + "media/images/emoticons/24hours-07fa106335d6398072ce5bae18d3a0a9.gif";